import useKeyboard from "./useKeyboard";
import { KeyMod, KeyCode } from "./codes";

export { KeyMod, KeyCode };
export type { UseKeyboardHandler, KeyboardOptions, KeyboardResult, UseKeyboard } from "./useKeyboard";
export default useKeyboard;
